// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"0aaa25d4","455":"5da58651","977":"9bf6bd9a"}[chunkId] + ".chunk.js";
};